import {Provider} from '@angular/core';
import {BALANCE_FETCHING_TRIGGER} from './balance-fetching-trigger';
import {Erc20BalancesSharedService} from './erc20-balances-shared.service';
import {Erc20BalanceUpdatesService} from './erc20-balances-updates.service';
import {Erc20BalancesService} from './erc20-balances.service';

export const ERC20_BALANCES_SHARED_PROVIDERS: Provider[] = [
    Erc20BalancesSharedService,
    {
        provide: Erc20BalancesService,
        useExisting: Erc20BalancesSharedService
    },
    Erc20BalanceUpdatesService,
    {
        provide: BALANCE_FETCHING_TRIGGER,
        useExisting: Erc20BalanceUpdatesService
    }
];
